import styled from '@emotion/styled';

// Page style
export const PageWrapper = styled.div`
  width: 100%;
  display: block;
`;

// Cover style
export const CoverWrapper = styled.div`
  position: relative;
  height: 184px;
  background: ${({ theme }) => theme.colors.neutralMain};
  margin-bottom: 20px;
`;

export const CoverBackButtonWrapper = styled.div`
  position: absolute;
  top: 16px;
  left: 120px;
  width: 85px;
  z-index: 10;
  ${({ theme }) => theme.media.mobile} {
    left: 40px;
  }
`;

export const CoverBackgroundWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  :after {
    content: ' ';
    position: absolute;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.colors.neutralMain};
    opacity: 0.5;
    top: 0;
    left: 0;
    z-index: 5;
  }
`;

// Content style
export const Content = styled.div`
  width: 100%;
  max-width: 800px;
  margin-inline: auto;
  @media screen and (max-width: 1040px) {
    padding: 0 32px;
  }
`;

// Details style
export const DetailsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
  ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
    gap: 16px;
  }
`;
export const AvatarNameWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
    gap: 8px;
  }
`;
export const AvatarWrapper = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.secondaryMain};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 4px solid ${({ theme }) => theme.colors.white};
  position: relative;
  margin-top: -40px;
  z-index: 15;
  ${({ theme }) => theme.media.mobile} {
    margin-top: 0;
  }
`;

export const FadedIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 84px;
  height: 84px;
  opacity: 0.04;
  z-index: -1;
`;

export const NameWrapper = styled.div``;
export const StatsWrapper = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex-wrap: wrap;
  gap: 4px;
  > div {
    flex-basis: calc(50% - 4px);
  }
  ${({ theme }) => theme.media.tablet} {
    flex-direction: column;
  }
`;
